<template>
  <div class="inventory-self-list-container">
    <h2 class="page-title">自发货盘管理</h2>

    <!-- 查询表单 -->
    <div class="search-form">
      <div class="search-row">
        <div class="search-col search-col-small">
          <div class="form-group">
            <label for="productName">产品名称</label>
            <el-input id="productName" v-model="search.productName" placeholder="模糊查询" :disabled="loading"></el-input>
          </div>
        </div>
        <div class="search-col search-col-small">
          <div class="form-group">
            <label for="sku">SKU</label>
            <el-input id="sku" v-model="search.sku" placeholder="模糊查询" :disabled="loading"></el-input>
          </div>
        </div>
        <div class="search-col search-col-small">
          <div class="form-group">
            <label for="warehouse">仓库</label>
            <el-select id="warehouse" v-model="search.warehouse" placeholder="请选择仓库" :disabled="loading" style="width: 100%" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="加纳" value="GH01"></el-option>
              <el-option label="肯尼亚" value="KE01"></el-option>
              <el-option label="乌干达" value="UG01"></el-option>
              <el-option label="尼日利亚" value="NG01"></el-option>
              <el-option label="巴基斯坦" value="PK02"></el-option>
            </el-select>
          </div>
        </div>
        <div class="search-col search-col-small" v-if="isAdminUser">
          <div class="form-group">
            <label for="salesman">归属人</label>
            <el-input id="salesman" v-model="search.salesman" placeholder="模糊查询" :disabled="loading"></el-input>
          </div>
        </div>
        <div class="search-col search-button-col">
          <el-button type="primary" @click="handleSearch" :disabled="loading" :loading="loading">
            查询
          </el-button>
        </div>
        <div class="search-col search-button-col" v-if="isAdminUser">
          <el-button type="success" @click="handleExport" :disabled="loading" :loading="exporting">
            导出
          </el-button>
        </div>
      </div>
    </div>

    <!-- 统计信息 -->
    <div class="summary-stats" v-if="hasData">
      <div class="stat-item">
        <span class="stat-label">总可售数量：</span>
        <span class="stat-value">{{ totalSellable }}</span>
      </div>
      <div class="stat-item">
        <span class="stat-label">参考总货值(在途+可售)：</span>
        <span class="stat-value">{{ totalProductModel }}</span>
      </div>
    </div>

    <!-- 库存表格 -->
    <div class="table-container">
      <table>
      <thead class="sticky-header">
        <tr>
          <th style="width: 11%">SKU</th>
          <th style="width: 8%">产品图片</th>
          <th style="width: 9%" v-if="isAdminUser">归属人</th>
          <th style="width: 14%">产品中文名</th>
          <th style="width: 9%">仓库</th>
          <th style="width: 7%">在途</th>
          <th style="width: 9%">可售数量</th>
          <th style="width: 9%">已出库</th>
          <th style="width: 15%">采购和头程总货值</th>
          <th style="width: 14%">最大库龄</th>
        </tr>
      </thead>
        <tbody>
          <!-- 加载中状态 -->
          <tr v-if="loading">
            <td :colspan="isAdminUser ? 10 : 9" style="text-align: center; padding: 20px;">
              <span v-if="$loading">
                <el-icon>
                  <Loading />
                </el-icon> 加载中...
              </span>
              <span v-else>加载中...</span>
            </td>
          </tr>

          <!-- 错误状态 -->
          <tr v-else-if="error">
            <td :colspan="isAdminUser ? 10 : 9" style="text-align: center; padding: 20px; color: #f56c6c;">
              {{ error }}
            </td>
          </tr>

          <!-- 无数据状态 -->
          <tr v-else-if="!hasData">
            <td :colspan="isAdminUser ? 10 : 9" style="text-align: center; padding: 20px;">
              暂无数据
            </td>
          </tr>

        <!-- 数据列表 -->
        <tr v-else v-for="item in inventoryList" :key="item.sku + '-' + item.warehouse">
          <td>{{ item.sku || '-' }}</td>
          <td>
            <img 
              v-if="item.pic" 
              :src="item.pic" 
              alt="产品图片" 
              class="product-image"
              @error="handleImageError($event)"
            >
            <span v-else>-</span>
          </td>
          <td v-if="isAdminUser">{{ item.salesman || '-' }}</td>
          <td>{{ item.skuName || '-' }}</td>
          <td>{{ formatWarehouse(item.warehouse) }}</td>
          <td>{{ item.onway || 0 }}</td>
          <td>{{ item.sellable || 0 }}</td>
          <td>{{ item.shipped || 0 }}</td>
          <td>{{ formatProductValue(item.productModel) }}</td>
          <td>{{ item.maxStockAge || 0 }}</td>
        </tr>
        </tbody>
      </table>

      <!-- 分页控件 -->
      <div class="pagination-container" v-if="hasData">
        <div class="page-size-selector">
          <span>每页显示：</span>
          <el-select v-model="pagination.pageSize" @change="handlePageSizeChange" :disabled="loading" size="small" style="width: 100px">
            <el-option label="10条" value="10"></el-option>
            <el-option label="100条" value="100"></el-option>
            <el-option label="1000条" value="1000"></el-option>
          </el-select>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          :total="pagination.totalItems"
          layout="total, prev, pager, next, jumper"
          :page-count="pagination.totalPages"
        >
        </el-pagination>
        <div class="pagination-info">
          <span>显示 {{ pagination.startIndex }}-{{ pagination.endIndex }} 条，共 {{ pagination.totalItems }} 条</span>
        </div>
      </div>
    </div>

    <!-- 悬浮滚动按钮 -->
    <div class="scroll-buttons">
      <button class="scroll-btn scroll-to-top" @click="scrollToTop" title="回到顶部">
        <i class="el-icon-arrow-up"></i>
      </button>
      <button class="scroll-btn scroll-to-bottom" @click="scrollToBottom" title="跳转到底部">
        <i class="el-icon-arrow-down"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InventorySelfList',
  data() {
    return {
      search: {
        productName: '',
        sku: '',
        salesman: '',
        warehouse: ''
      },
      inventoryList: [],
      loading: false,
      error: null,
      exporting: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        totalItems: 0,
        totalPages: 0,
        pages: [],
        startPage: 0,
        endPage: 0
      },
      // 统计数据
      totalSellable: 0,
      totalProductModel: 0
    }
  },
  computed: {
    hasData() {
      return this.inventoryList && this.inventoryList.length > 0
    },
    isAdminUser() {
      try {
        const userInfoStr = localStorage.getItem('userInfo')
        if (userInfoStr) {
          const userInfo = JSON.parse(userInfoStr)
          return userInfo.isAdmin === true || userInfo.roleType === 1;
        }
        return false
      } catch (error) {
        console.error('解析用户信息失败:', error)
        return false
      }
    }
  },
  created() {
    this.fetchInventoryData()
  },
  methods: {
    /**
     * 查询库存数据
     */
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchInventoryData()
    },
    
    /**
     * 获取库存数据
     */
    fetchInventoryData() {
      this.loading = true
      this.error = null

      const requestData = {
        ...this.search,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize
      }

      // 移除空字符串值
      Object.keys(requestData).forEach(key => {
        if (requestData[key] === null || requestData[key] === undefined || requestData[key] === '') {
          delete requestData[key]
        }
      })

      this.axios.post('/data-serv/inventory/self-list', requestData)
        .then(response => {
          if (response.data.code === 0 && response.data.data) {
            const data = response.data.data.palletPage
            this.pagination.totalItems = data.totalRows || 0
            this.pagination.totalPages = Math.ceil(this.pagination.totalItems / this.pagination.pageSize)
            this.inventoryList = data.list || []

            // 从接口响应中读取统计数据
            this.totalSellable = response.data.data.totalSellable || 0
            this.totalProductModel = response.data.data.totalProductModel || 0

            // 计算分页显示范围
            this.calculatePagination()
          } else {
            throw new Error(response.data.message || '获取自发货盘数据失败')
          }
        })
        .catch(error => {
          console.error('获取自发货盘数据失败:', error)
          this.error = error.message || '获取自发货盘数据失败'
          this.inventoryList = []
          this.pagination.totalItems = 0
          this.pagination.totalPages = 0
          this.totalSellable = 0
          this.totalProductModel = 0
        })
        .finally(() => {
          this.loading = false
        })
    },

    /**
     * 计算分页
     */
    calculatePagination() {
      const maxVisiblePages = 7
      let startPage = Math.max(1, this.pagination.currentPage - Math.floor(maxVisiblePages / 2))
      let endPage = Math.min(this.pagination.totalPages, startPage + maxVisiblePages - 1)
      
      // 调整起始页，确保显示足够的页面
      if (endPage - startPage + 1 < maxVisiblePages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1)
      }

      this.pagination.startPage = startPage
      this.pagination.endPage = endPage

      // 生成分页数组
      this.pagination.pages = []
      for (let i = startPage; i <= endPage; i++) {
        this.pagination.pages.push(i)
      }

      // 计算显示范围
      this.pagination.startIndex = (this.pagination.currentPage - 1) * this.pagination.pageSize + 1
      this.pagination.endIndex = Math.min(this.pagination.currentPage * this.pagination.pageSize, this.pagination.totalItems)
    },

    /**
     * 处理当前页码变化
     */
    handleCurrentChange(page) {
      if (page < 1 || page > this.pagination.totalPages || page === this.pagination.currentPage) {
        return
      }
      this.pagination.currentPage = page
      this.fetchInventoryData()
    },

    /**
     * 处理每页条数变化
     */
    handlePageSizeChange(pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.currentPage = 1
      this.fetchInventoryData()
    },

    /**
     * 处理导出功能
     */
    handleExport() {
      this.exporting = true
      
      const requestData = { ...this.search }

      // 移除空字符串值
      Object.keys(requestData).forEach(key => {
        if (requestData[key] === null || requestData[key] === undefined || requestData[key] === '') {
          delete requestData[key]
        }
      })

      this.axios.post('/data-serv/inventory/self-list/export', requestData, {
        responseType: 'blob' // 设置响应类型为blob以处理文件下载
      })
        .then(response => {
          // 创建下载链接
          const blob = new Blob([response.data], {
            type: response.headers['content-type'] || 'application/octet-stream'
          })
          
          // 从响应头中获取文件名
          let filename = '自发货盘数据.xlsx'
          const contentDisposition = response.headers['content-disposition']
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename\*?=([^;]+)/i)
            if (filenameMatch) {
              filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''))
            }
          }
          
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          link.download = filename
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          
          this.$message.success('导出成功')
        })
        .catch(error => {
          console.error('导出失败:', error)
          this.$message.error(error.message || '导出失败')
        })
        .finally(() => {
          this.exporting = false
        })
    },

    /**
     * 格式化仓库显示
     */
    formatWarehouse(warehouseCode) {
      const warehouseMap = {
        'GH01': '加纳',
        'KE01': '肯尼亚',
        'UG01': '乌干达',
        'NG01': '尼日利亚',
        'PK02': '巴基斯坦'
      }
      return warehouseMap[warehouseCode] || warehouseCode || '-'
    },

    /**
     * 格式化产品货值
     */
    formatProductValue(value) {
      if (!value) return '-'
      return `${value}`
    },

    /**
     * 处理图片加载错误
     */
    handleImageError(event) {
      event.target.style.display = 'none'
      event.target.nextSibling.style.display = 'inline'
    },

    /**
     * 滚动到页面顶部
     */
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },

    /**
     * 滚动到页面底部
     */
    scrollToBottom() {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
.inventory-self-list-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100%;
  box-sizing: border-box;
}

.page-title {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 20px;
  text-align: center;
}

/* 查询表单样式 */
.search-form {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.search-row {
  display: flex;
  margin-bottom: 15px;
  gap: 15px;
}

.search-col {
  flex: 1;
  min-width: 0;
}

.search-col-small {
  flex: 1;
  min-width: 120px;
  max-width: 200px;
}

.search-button-col {
  flex: 0 0 100px;
  display: flex;
  align-items: flex-end;
  margin-bottom: 0;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
  font-weight: 500;
}

/* 统计信息样式 */
.summary-stats {
  background-color: white;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  gap: 30px;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.stat-label {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

.stat-value {
  font-size: 16px;
  color: #409eff;
  font-weight: bold;
}

/* 表格样式 */
.table-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.table-container table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.sticky-header {
  position: sticky;
  top: 0;
  background-color: #f5f7fa;
  z-index: 10;
}

.table-container th {
  text-align: center;
  padding: 12px 16px;
  font-weight: 600;
  color: #606266;
  border-bottom: 1px solid #ebeef5;
  font-size: 14px;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  word-wrap: break-word;
}

.table-container td {
  padding: 12px 16px;
  border-bottom: 1px solid #ebeef5;
  color: #606266;
  font-size: 14px;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  word-wrap: break-word;
  word-break: break-word;
}

.table-container tr:hover {
  background-color: #f5f7fa;
}

/* 产品图片样式 */
.product-image {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
}

.product-image:hover {
  transform: scale(1.5);
  transition: transform 0.3s ease;
  position: relative;
  z-index: 100;
}

/* 分页样式 */
.pagination-container {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  border-top: 1px solid #ebeef5;
}

.page-size-selector {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #606266;
}

.pagination-info {
  font-size: 14px;
  color: #606266;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .inventory-self-list-container {
    padding: 10px;
  }

  .search-row {
    flex-direction: column;
    gap: 10px;
  }

  .search-col,
  .search-col-small {
    flex: none;
    min-width: auto;
    max-width: none;
  }

  .search-button-col {
    flex: none;
    align-items: stretch;
  }

  .summary-stats {
    flex-direction: column;
    gap: 15px;
  }

  .table-container th,
  .table-container td {
    padding: 8px 12px;
    font-size: 12px;
  }

  .pagination-container {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }

  .page-size-selector {
    justify-content: center;
  }

  .pagination-info {
    text-align: center;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
  }

  .search-form {
    padding: 15px;
  }

  .table-container th,
  .table-container td {
    padding: 6px 8px;
    font-size: 11px;
  }
}

/* 悬浮滚动按钮样式 */
.scroll-buttons {
  position: fixed;
  right: 30px;
  bottom: 50px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1000;
}

.scroll-btn {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: none;
  background-color: #909399;
  color: white;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.scroll-btn .el-icon-arrow-up,
.scroll-btn .el-icon-arrow-down {
  font-size: 24px;
  color: white;
}

.scroll-btn:hover {
  background-color: #a6a9ad;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.scroll-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* 响应式设计 - 移动端隐藏悬浮按钮 */
@media (max-width: 768px) {
  .scroll-buttons {
    display: none;
  }
}
</style>